module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-profile__form"
  }, [(!_vm.isEditable && _vm.canEdit) ? _c('div', {
    staticClass: "d-profile__form__edit",
    on: {
      "click": function($event) {
        _vm.isEditable = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.edit')))]) : _vm._e(), _vm._v(" "), (!_vm.isEditable) ? _c('div', {
    staticClass: "d-input-group__un-edit"
  }, [_c('h3', [_vm._v("CPR nummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ssnHidden))])]) : [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', [_vm._v("CPR nummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ssn),
      expression: "ssn",
      modifiers: {
        "trim": true
      }
    }],
    class: {
      'input--error': _vm.formErrors['ssn']
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ssn)
    },
    on: {
      "keyup": function($event) {
        return _vm.removeErrors('ssn')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ssn = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.formErrors['ssn']) ? _c('p', {
    staticClass: "input-error"
  }, [_vm._v("\n        " + _vm._s(_vm.formErrors['ssn']) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-profile__form__submit"
  }, [_c('button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    class: [{
        'bttn--loading': _vm.isSaving
      },
      {
        'submit-button--disabled': _vm.isSaveButtonDisabled
      }
    ],
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cb84e82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ProfileSSN.vue
// module id = 1570
// module chunks = 1